'use client';

import React, { createContext, useContext } from 'react';
import { CrystallizeProductData } from '@/ui/components/pages/ProductDetail/types/CrystallizeProductData';

const ProductDetailDataContext = createContext<CrystallizeProductData | null>(null);

export interface ProductDetailDataProviderProps {
  data: CrystallizeProductData;
  children: React.ReactNode;
}

/**
 * Publishes the product payload of the surrounding product detail page to the
 * client tree, so tiles placed by editors can render product content without
 * the page having to pass it down through the tile renderers.
 */
export function ProductDetailDataProvider({
  data,
  children,
}: Readonly<ProductDetailDataProviderProps>) {
  // The value is the payload itself, so it changes only when the page changes
  // and needs no memoised wrapper object.
  return (
    <ProductDetailDataContext.Provider value={data}>{children}</ProductDetailDataContext.Provider>
  );
}

/** Returns `null` outside a product detail page. */
export function useProductDetailData(): CrystallizeProductData | null {
  return useContext(ProductDetailDataContext);
}
